// DS3.1 - No label / no bottom padding version
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef, useState } from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';
import InputFieldOutline from '../InputFieldOutline';
import BaseInput from '../BaseInput';
import s from './InputField.scss';
/**
 * One of our standard `<input />`s.
 *
 * Provides space for a prefix and postfix, and allows indication of success or error via `validationResult`.
 */ const InputField = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { type = 'text', prefix, postfix, validationResult, className, inputClassname, disabled, onFocus: onFocusProp, onBlur: onBlurProp } = _param, rest = _object_without_properties(_param, [
        "type",
        "prefix",
        "postfix",
        "validationResult",
        "className",
        "inputClassname",
        "disabled",
        "onFocus",
        "onBlur"
    ]);
    const [isFocused, setIsFocused] = useState(false);
    const onFocus = (e)=>{
        setIsFocused(true);
        onFocusProp && onFocusProp(e);
    };
    const onBlur = (e)=>{
        setIsFocused(false);
        onBlurProp && onBlurProp(e);
    };
    const localInputRef = useRef();
    return /*#__PURE__*/ React.createElement(InputFieldOutline, {
        className: c(s['root'], isFocused && s['focused'], disabled && s['disabled'], className),
        outlineStyle: disabled ? 'disabled' : validationResult,
        onClick: ()=>localInputRef.current && localInputRef.current.focus()
    }, prefix && /*#__PURE__*/ React.createElement("span", {
        className: s['prefix']
    }, prefix), /*#__PURE__*/ React.createElement(BaseInput, _object_spread({
        type: type,
        className: c(s['input'], inputClassname),
        disabled: disabled,
        "aria-invalid": validationResult === 'error',
        ref: (node)=>{
            if (isFunction(ref)) {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
            localInputRef.current = node;
        },
        onFocus: onFocus,
        onBlur: onBlur
    }, rest)), postfix && /*#__PURE__*/ React.createElement("span", {
        className: s['postfix']
    }, postfix));
});
InputField.displayName = 'InputField';
export default InputField;
